import { makeStyles, createStyles } from '@material-ui/styles'

export const AppSearchBarStyles = makeStyles((theme) =>
  createStyles({
    searchBar: {
      backgroundColor: theme.palette.backgroundColor.secondary,
      width: '100%',
    },
  }),
)

export default AppSearchBarStyles
